import { appendPrefixFn } from "../utils/string.utils";

export const prefixPublic = appendPrefixFn('/public/');
export const prefixAuth = appendPrefixFn('/auth/');
export const prefixClient = appendPrefixFn('/client/');
export const prefixOwn = appendPrefixFn('/own/');
export const prefixStaff = appendPrefixFn('/staff/');
